import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  AddCurrencyAccountWidgetConfig,
  baseCssConfigStyle,
  commonContentStyleList,
  commonTextContentStyleList,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-add-currency-account-widget',
  templateUrl: './add-currency-account-widget.component.html',
  styleUrl: './add-currency-account-widget.component.scss',
})
export class AddCurrencyAccountWidgetComponent extends BaseComponent {
  public textContentStyle: baseCssConfigStyle;
  public searchIconStyle: baseCssConfigStyle;
  public widgetAttributes: UiZoneWidgetAttributeConfig = {
    widgetProperties: { textContent: '' },
  } as UiZoneWidgetAttributeConfig;

  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<AddCurrencyAccountWidgetConfig>,
  ) {
    super();
    if (this.dataIn?.attri) {
      this.widgetAttributes = this.dataIn.attri;
    }
    this.getWidgetCssConfig();
  }

  private getWidgetCssConfig() {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonContentStyleList,
    );

    this.textContentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonTextContentStyleList,
    );

    const { iconStyle } = this.configService.getInputFieldCssStyles(
      this.widgetAttributes.widgetProperties ?? {},
    );

    this.searchIconStyle = iconStyle;
  }
}
